(function ($) {
    let $destinationsSlider = $('.destinations-slider');
    let $itinerariesSlider = $('.itineraries-slider');
    let $contentSlider = $('.content-slider');
    let $quoteSlider = $('.quote-slider');
    let $destinationsStatus = $('.destinations-paging-info');
    let $itinerariesStatus = $('.itineraries-paging-info');
    let $contentStatus = $('.content-paging-info');
    let $quoteStatus = $('.quote-paging-info');

    var initializeBlock = function ($block) {
        if ($('.destinations-slider .slide').length > 0) {
            $destinationsSlider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
                if (!slick.$dots) {
                    return;
                }

                let i = (currentSlide ? currentSlide : 0) + 1;
                $destinationsStatus.text(i + ' / ' + slick.$dots[0].children.length);
            });

            // Initialize card carousel
            $destinationsSlider.slick({
                autoplay: false,
                autoplaySpeed: 7000,
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: true,
                arrows: true,
                appendArrows: '.destinations-slider-nav',
                prevArrow: "<button type='button' class='slick-prev'><i class='fal fa-chevron-left'></i></button>",
                nextArrow: "<button type='button' class='slick-next'><i class='fal fa-chevron-right'></i></button>",
                fade: false,
                adaptiveHeight: false,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });
        }

        if ($('.itineraries-slider .slide').length > 0) {
            $itinerariesSlider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
                if (!slick.$dots) {
                    return;
                }

                let i = (currentSlide ? currentSlide : 0) + 1;
                $itinerariesStatus.text(i + ' / ' + slick.$dots[0].children.length);
            });

            // Initialize card carousel
            $itinerariesSlider.slick({
                autoplay: false,
                autoplaySpeed: 7000,
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: true,
                arrows: true,
                appendArrows: '.itineraries-slider-nav',
                prevArrow: "<button type='button' class='slick-prev'><i class='fal fa-chevron-left'></i></button>",
                nextArrow: "<button type='button' class='slick-next'><i class='fal fa-chevron-right'></i></button>",
                fade: false,
                adaptiveHeight: false,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });
        }

        $('.venues-slider').each(function (key, item) {
            let sliderIdName = 'slider-' + key;
            let sliderId = '#' + sliderIdName;
            let sliderNavIdName = 'slider-nav-' + key;
            let sliderNavId = '#' + sliderNavIdName;

            this.id = sliderIdName;
            $(this).next().find('.slider-nav').prop('id', sliderNavIdName);

            if ($(this).find('.slide').length > 0) {
                $(sliderId).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
                    if (!slick.$dots) {
                        return;
                    }

                    let i = (currentSlide ? currentSlide : 0) + 1;
                    $(sliderNavId)
                        .find('.venues-paging-info')
                        .text(i + ' / ' + slick.$dots[0].children.length);
                });

                // Initialize card carousel
                $(sliderId).slick({
                    autoplay: false,
                    autoplaySpeed: 7000,
                    infinite: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: true,
                    appendArrows: sliderNavId,
                    prevArrow: "<button type='button' class='slick-prev'><i class='fal fa-chevron-left'></i></button>",
                    nextArrow: "<button type='button' class='slick-next'><i class='fal fa-chevron-right'></i></button>",
                    fade: false,
                    adaptiveHeight: false,
                    responsive: [
                        {
                            breakpoint: 575,
                            settings: {
                                slidesToShow: 1,
                            },
                        },
                    ],
                });
            }
        });

        if ($('.content-slider .slide').length > 0) {
            $contentSlider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
                if (!slick.$dots) {
                    return;
                }

                let i = (currentSlide ? currentSlide : 0) + 1;
                $contentStatus.text(i + ' / ' + slick.$dots[0].children.length);
            });

            // Initialize card carousel
            $contentSlider.slick({
                autoplay: false,
                autoplaySpeed: 7000,
                infinite: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: true,
                arrows: true,
                appendArrows: '.content-slider-nav',
                prevArrow: "<button type='button' class='slick-prev'><i class='fal fa-chevron-left'></i></button>",
                nextArrow: "<button type='button' class='slick-next'><i class='fal fa-chevron-right'></i></button>",
                fade: false,
                adaptiveHeight: false,
                responsive: [
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });
        }

        if ($('.quote-slider .slide').length > 0) {
            $quoteSlider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
                if (!slick.$dots) {
                    return;
                }

                let i = (currentSlide ? currentSlide : 0) + 1;
                $quoteStatus.text(i + ' / ' + slick.$dots[0].children.length);
            });

            // Initialize quote carousel
            $quoteSlider.slick({
                autoplay: false,
                autoplaySpeed: 7000,
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: true,
                appendArrows: '.quote-slider-nav',
                prevArrow: "<button type='button' class='slick-prev'><i class='fal fa-chevron-left'></i></button>",
                nextArrow: "<button type='button' class='slick-next'><i class='fal fa-chevron-right'></i></button>",
                fade: false,
                adaptiveHeight: false,
            });
        }
    };

    // Initialize each block on page load (front end).
    $(document).on('ready', function () {
        initializeBlock();
    });

    // Initialize dynamic block preview (editor).
    if (window.acf) {
        window.acf.addAction('render_block_preview', initializeBlock);
    }
})(jQuery);
